module.exports = __webpack_public_path__ + "static/media/game_icon_capybara.83664247.png";